export const androidOsType = 'android'
export const iOsOsType = 'ios'
export const defaultOsType = 'default'

export type OsTypes =
  | typeof androidOsType
  | typeof iOsOsType
  | typeof defaultOsType
